import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconPatrimonioImobilizado,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    tituloEstudoGarantiaCliente,
    tituloEstudoGarantiaConjuge,
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormGarantiasPatrimonioImobilizado = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } ) => {

    const GarantiasPatrimonioImobilizado = () => {

        let headList = [
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoPatrimonioImobilizado, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
        ]

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaCliente(values), report
                            ),
                },
            )
        }
    
        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                tituloEstudoGarantiaConjuge(values), report
                            ),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.patrimonioImobilizado?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>

                                {dadosCompletosCliente(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaCliente}
                                    </TableCellBodyExibeDados>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaConjuge}
                                    </TableCellBodyExibeDados>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }

    return (
        <DivFormEstudo>
                {report || relatorioModoApresentacao(values)
                    ?
                        //<div
                        //    className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                        //>
                        <>
                            <div
                                className={CLASSNAME().formataReportDetalhamento}
                                align='left'
                            >
                                {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoPatrimonioImobilizadoTextoCabecalho
                                    ?
                                        <>
                                            {jsonConfiguracao.estudoReportDetalhamentoPatrimonioImobilizadoTextoCabecalho}
                                            <br/>
                                            <br/>
                                            <br/>
                                        </>
                                    :
                                        MESSAGE().estudoReportDetalhamentoPatrimonioImobilizadoTextoCabecalho
                                }
                            </div>
                            
                            <GarantiasPatrimonioImobilizado />
                        </>
                        //</div>
                    :
                        <CardGridEstudoTabelaPadrao
                            values={values}
                            SvgIcon={SvgIconPatrimonioImobilizado}
                            label={LABEL.patrimonioImobilizado}
                            helpTextMorte={HELPTEXT.estudoPatrimonioImobilizado}
                            helpTextInvalidez={HELPTEXT.estudoPatrimonioImobilizado}
                            component={<GarantiasPatrimonioImobilizado/>}
                            popup={true}
                        />
                }
        </DivFormEstudo>
    )
}

export default EstudoFormGarantiasPatrimonioImobilizado